import { useLocation } from 'react-router'
import { useCartStoreOrNull } from 'stores/cartStore/CartStoreProvider'
import { useMobxSelector } from 'utils/mobx/useMobxSelector'
import { isCartExcludedPath } from '../cart.consts'

// Whether checkout places the bag as a group order. Kept free of loading state, so an order
// doesn't change shape while a promo code reloads the discounts.
export function useIsCartCheckout(): boolean {
  const cartStore = useCartStoreOrNull()
  const { pathname } = useLocation()
  const hasPricingPayloads = useMobxSelector(
    () => !!cartStore && cartStore.getPricingPayloads().length > 0,
    []
  )
  return !isCartExcludedPath(pathname) && hasPricingPayloads
}
